export default __webpack_public_path__ + "static/media/AMZN_FR_DE_SH_SD.e4a80b3e.svg";